<ng-container [formGroup]="formGroup">
  <span class="p-float-label" [class]="validation()">
    <input
      [id]="'float-input__' + fieldName"
      [formControlName]="fieldName"
      [mask]="MASK.PHONE_MASK"
      [showMaskTyped]="true"
      prefix="+7"
      pInputText
    />
    <label [for]="'float-input__' + fieldName">{{ formatFieldName(placeholder) }}</label>
  </span>
  <app-error-message
    [control]="$any(formGroup.controls[this.fieldName])"
    [field]="fieldName"
    [label]="placeholder"
  ></app-error-message>
</ng-container>
